import { combineReducers } from 'redux';
import { createMigrate, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import downloads from './jobs.reducer';

const downloadsReducers = combineReducers({
  downloads,
});

const migrations = {
  2: (state: any) => ({
    ...state,
    downloads: {
      downloads: {
        jobs: state.downlaods.downlaods.jobs,
        requestedJobs: [],
      },
    },
  }),
};

const downloadsReducerPersistConfig = {
  key: 'downloads',
  version: 2,
  storage,
  migrate: createMigrate(migrations, { debug: true }),
};

export default persistReducer(downloadsReducerPersistConfig, downloadsReducers);
